import Loader from "@/components/Loader";
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import { getFavoriteListRequest } from '@/store/favorite/actions';
import { Favorite } from '@/store/favorite/types';
import { getWordCloudCategoriesDataClear, getWordCloudCategoriesDataRequest } from '@/store/learningMap/action';
import { WordCloudCategory } from '@/store/learningMap/types';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TagCloud } from 'react-tagcloud';
import "./style.scss";
interface TagData {
    key: string,
    value: string,
    count: number,
    color: string,
}

const GRAY_COLOR = '#4D4D4D';

const isFavorited = (list: Favorite[]) => (item: WordCloudCategory) => Boolean(
    list.find(
        ({ contentId, contentType }: Favorite) => (
            contentType === Constants.entityTypes.CATEGORY &&
            contentId === item.categoryId
        )
    )
);

const createWordList = (wordcloudCategories: WordCloudCategory[], favorities: Favorite[], orgColor: string): TagData[] => {
    const favorited = isFavorited(favorities);
    return wordcloudCategories.map(
        (c: WordCloudCategory) => ({
            key: String(c.categoryId),
            value: c.categoryName,
            count: c.wordCloudPoints,
            color: favorited(c) ? orgColor : GRAY_COLOR,
        })
    );
};

const CategoriesWordCloud: React.FC = () => {
    const history = useHistory();
    const { strings, orgColor, favoriteList, wordcloudCategories } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        orgColor: state.appOrganization.data.colors[0],
        favoriteList: state.favorite.favoriteList,
        wordcloudCategories: state.learningMap.wordcloudCategories,
    }));
    const [loading, setLoading] = useState<boolean>(true);
    const [wordList, setWordList] = useState<TagData[]>([]);
    const containerRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();

    const onWordClick = (word: TagData): void => {
        const w = word;
        history.push(`/category/${w.key}`);
    };

    const noWordConsumed: boolean = wordList.every(word => word.count === 1)

    useEffect(() => {
        dispatch(getFavoriteListRequest(false));
        dispatch(getWordCloudCategoriesDataRequest({
            moduleIds: Constants.PLAYLIST_MODULE_ID.toString()
        }));
        return () => {
            dispatch(getWordCloudCategoriesDataClear());
        }
    }, []);

    useEffect(() => {
        if (wordcloudCategories.length > 0) {
            setWordList(createWordList(wordcloudCategories, favoriteList, orgColor));
            setLoading(false);
        }
    }, [wordcloudCategories.length]);

    return (
        <div className="categories-word-cloud" ref={containerRef}>
            <h4 className="section-title">{strings.MOST_VIEWED_CATEGORIES}</h4>
            {loading ? (
                <Loader />
            ) : (
                <TagCloud
                    minSize={15}
                    maxSize={noWordConsumed ? 15 : 40}
                    tags={wordList}
                    onClick={onWordClick}
                    shuffle={true}
                    className="tag-word-cloud"
                />
            )}
        </div>
    );
};

export default CategoriesWordCloud;
